//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @author Rico
import baseFrom from "./baseForm";
export default {
  extends: baseFrom,
  props: {
    submittext: {
      type: String,
      default: "登录",
    },
  },
  data() {
    return {
      action: "password-free-login",
      form: {
        telephone: "",
        country_code: "+86",
        email: "",
        captcha: "",
      },
      activeWay: "phone",
      scene: "login",
      localCodes: [
        {
          code: "+86",
          area: "中国大陆",
          key: "+86:中国大陆",
        },
        {
          code: "+886",
          area: "中国台湾地区",
          key: "+886:中国台湾地区",
        },
        {
          code: "+852",
          area: "中国香港",
          key: "+852:中国香港",
        },
        {
          code: "+60",
          area: "马来西亚",
          key: "+60:马来西亚",
        },
        {
          code: "+65",
          area: "新加坡",
          key: "+65:新加坡",
        },
        {
          code: "+81",
          area: "日本",
          key: "+81:日本",
        },
        {
          code: "+82",
          area: "韩国",
          key: "+82:韩国",
        },
        {
          code: "+1",
          area: "美国",
          key: "+1:美国",
        },
        {
          code: "+1",
          area: "加拿大",
          key: "+1:加拿大",
        },
        {
          code: "+61",
          area: "澳大利亚",
          key: "+61:澳大利亚",
        },
        {
          code: "+64",
          area: "新西兰",
          key: "+64:新西兰",
        },
        {
          code: "+355",
          area: "阿尔巴尼亚",
          key: "+355:阿尔巴尼亚",
        },
        {
          code: "+54",
          area: "阿根廷",
          key: "+54:阿根廷",
        },
        {
          code: "+971",
          area: "阿联酋",
          key: "+971:阿联酋",
        },
        {
          code: "+968",
          area: "阿曼",
          key: "+968:阿曼",
        },
        {
          code: "+994",
          area: "阿塞拜疆",
          key: "+994:阿塞拜疆",
        },
        {
          code: "+353",
          area: "爱尔兰",
          key: "+353:爱尔兰",
        },
        {
          code: "+20",
          area: "埃及",
          key: "+20:埃及",
        },
        {
          code: "+372",
          area: "爱沙尼亚",
          key: "+372:爱沙尼亚",
        },
        {
          code: "+244",
          area: "安哥拉",
          key: "+244:安哥拉",
        },
        {
          code: "+43",
          area: "奥地利",
          key: "+43:奥地利",
        },
        {
          code: "+853",
          area: "中国澳门",
          key: "+853:中国澳门",
        },
        {
          code: "+675",
          area: "巴布亚新几内亚",
          key: "+675:巴布亚新几内亚",
        },
        {
          code: "+1242",
          area: "巴哈马",
          key: "+1242:巴哈马",
        },
        {
          code: "+970",
          area: "巴勒斯坦",
          key: "+970:巴勒斯坦",
        },
        {
          code: "+973",
          area: "巴林",
          key: "+973:巴林",
        },
        {
          code: "+507",
          area: "巴拿马",
          key: "+507:巴拿马",
        },
        {
          code: "+55",
          area: "巴西",
          key: "+55:巴西",
        },
        {
          code: "+375",
          area: "白俄罗斯",
          key: "+375:白俄罗斯",
        },
        {
          code: "+359",
          area: "保加利亚",
          key: "+359:保加利亚",
        },
        {
          code: "+229",
          area: "贝宁",
          key: "+229:贝宁",
        },
        {
          code: "+32",
          area: "比利时",
          key: "+32:比利时",
        },
        {
          code: "+51",
          area: "秘鲁",
          key: "+51:秘鲁",
        },
        {
          code: "+48",
          area: "波兰",
          key: "+48:波兰",
        },
        {
          code: "+591",
          area: "玻利维亚",
          key: "+591:玻利维亚",
        },
        {
          code: "+501",
          area: "伯利兹",
          key: "+501:伯利兹",
        },
        {
          code: "+226",
          area: "布基纳法索",
          key: "+226:布基纳法索",
        },
        {
          code: "+240",
          area: "赤道几内亚",
          key: "+240:赤道几内亚",
        },
        {
          code: "+45",
          area: "丹麦",
          key: "+45:丹麦",
        },
        {
          code: "+49",
          area: "德国",
          key: "+49:德国",
        },
        {
          code: "+228",
          area: "多哥",
          key: "+228:多哥",
        },
        {
          code: "+7",
          area: "俄罗斯",
          key: "+7:俄罗斯",
        },
        {
          code: "+33",
          area: "法国",
          key: "+33:法国",
        },
        {
          code: "+63",
          area: "菲律宾",
          key: "+63:菲律宾",
        },
        {
          code: "+358",
          area: "芬兰",
          key: "+358:芬兰",
        },
        {
          code: "+238",
          area: "佛得角",
          key: "+238:佛得角",
        },
        {
          code: "+220",
          area: "冈比亚",
          key: "+220:冈比亚",
        },
        {
          code: "+1473",
          area: "格林纳达",
          key: "+1473:格林纳达",
        },
        {
          code: "+995",
          area: "格鲁吉亚",
          key: "+995:格鲁吉亚",
        },
        {
          code: "+57",
          area: "哥伦比亚",
          key: "+57:哥伦比亚",
        },
        {
          code: "+506",
          area: "哥斯达黎加",
          key: "+506:哥斯达黎加",
        },
        {
          code: "+592",
          area: "圭亚那",
          key: "+592:圭亚那",
        },
        {
          code: "+31",
          area: "荷兰",
          key: "+31:荷兰",
        },
        {
          code: "+504",
          area: "洪都拉斯",
          key: "+504:洪都拉斯",
        },
        {
          code: "+253",
          area: "吉布提",
          key: "+253:吉布提",
        },
        {
          code: "+996",
          area: "吉尔吉斯斯坦",
          key: "+996:吉尔吉斯斯坦",
        },
        {
          code: "+224",
          area: "几内亚",
          key: "+224:几内亚",
        },
        {
          code: "+245",
          area: "几内亚比绍",
          key: "+245:几内亚比绍",
        },
        {
          code: "+241",
          area: "加蓬",
          key: "+241:加蓬",
        },
        {
          code: "+855",
          area: "柬埔寨",
          key: "+855:柬埔寨",
        },
        {
          code: "+263",
          area: "津巴布韦",
          key: "+263:津巴布韦",
        },
        {
          code: "+237",
          area: "喀麦隆",
          key: "+237:喀麦隆",
        },
        {
          code: "+974",
          area: "卡塔尔",
          key: "+974:卡塔尔",
        },
        {
          code: "+1345",
          area: "开曼群岛",
          key: "+1345:开曼群岛",
        },
        {
          code: "+385",
          area: "克罗地亚",
          key: "+385:克罗地亚",
        },
        {
          code: "+269",
          area: "科摩罗",
          key: "+269:科摩罗",
        },
        {
          code: "+965",
          area: "科威特",
          key: "+965:科威特",
        },
        {
          code: "+254",
          area: "肯尼亚",
          key: "+254:肯尼亚",
        },
        {
          code: "+371",
          area: "拉脱维亚",
          key: "+371:拉脱维亚",
        },
        {
          code: "+266",
          area: "莱索托",
          key: "+266:莱索托",
        },
        {
          code: "+370",
          area: "立陶宛",
          key: "+370:立陶宛",
        },
        {
          code: "+352",
          area: "卢森堡",
          key: "+352:卢森堡",
        },
        {
          code: "+250",
          area: "卢旺达",
          key: "+250:卢旺达",
        },
        {
          code: "+40",
          area: "罗马尼亚",
          key: "+40:罗马尼亚",
        },
        {
          code: "+261",
          area: "马达加斯加",
          key: "+261:马达加斯加",
        },
        {
          code: "+960",
          area: "马尔代夫",
          key: "+960:马尔代夫",
        },
        {
          code: "+265",
          area: "马拉维",
          key: "+265:马拉维",
        },
        {
          code: "+223",
          area: "马里",
          key: "+223:马里",
        },
        {
          code: "+230",
          area: "毛里求斯",
          key: "+230:毛里求斯",
        },
        {
          code: "+222",
          area: "毛里塔尼亚",
          key: "+222:毛里塔尼亚",
        },
        {
          code: "+976",
          area: "蒙古",
          key: "+976:蒙古",
        },
        {
          code: "+373",
          area: "摩尔多瓦",
          key: "+373:摩尔多瓦",
        },
        {
          code: "+212",
          area: "摩洛哥",
          key: "+212:摩洛哥",
        },
        {
          code: "+258",
          area: "莫桑比克",
          key: "+258:莫桑比克",
        },
        {
          code: "+52",
          area: "墨西哥",
          key: "+52:墨西哥",
        },
        {
          code: "+264",
          area: "纳米比亚",
          key: "+264:纳米比亚",
        },
        {
          code: "+27",
          area: "南非",
          key: "+27:南非",
        },
        {
          code: "+505",
          area: "尼加拉瓜",
          key: "+505:尼加拉瓜",
        },
        {
          code: "+227",
          area: "尼日尔",
          key: "+227:尼日尔",
        },
        {
          code: "+234",
          area: "尼日利亚",
          key: "+234:尼日利亚",
        },
        {
          code: "+47",
          area: "挪威",
          key: "+47:挪威",
        },
        {
          code: "+351",
          area: "葡萄牙",
          key: "+351:葡萄牙",
        },
        {
          code: "+46",
          area: "瑞典",
          key: "+46:瑞典",
        },
        {
          code: "+41",
          area: "瑞士",
          key: "+41:瑞士",
        },
        {
          code: "+503",
          area: "萨尔瓦多",
          key: "+503:萨尔瓦多",
        },
        {
          code: "+381",
          area: "塞尔维亚",
          key: "+381:塞尔维亚",
        },
        {
          code: "+232",
          area: "塞拉利昂",
          key: "+232:塞拉利昂",
        },
        {
          code: "+221",
          area: "塞内加尔",
          key: "+221:塞内加尔",
        },
        {
          code: "+357",
          area: "塞浦路斯",
          key: "+357:塞浦路斯",
        },
        {
          code: "+248",
          area: "塞舌尔",
          key: "+248:塞舌尔",
        },
        {
          code: "+966",
          area: "沙特阿拉伯",
          key: "+966:沙特阿拉伯",
        },
        {
          code: "+94",
          area: "斯里兰卡",
          key: "+94:斯里兰卡",
        },
        {
          code: "+421",
          area: "斯洛伐克",
          key: "+421:斯洛伐克",
        },
        {
          code: "+386",
          area: "斯洛文尼亚",
          key: "+386:斯洛文尼亚",
        },
        {
          code: "+268",
          area: "斯威士兰",
          key: "+268:斯威士兰",
        },
        {
          code: "+597",
          area: "苏里南",
          key: "+597:苏里南",
        },
        {
          code: "+992",
          area: "塔吉克斯坦",
          key: "+992:塔吉克斯坦",
        },
        {
          code: "+66",
          area: "泰国",
          key: "+66:泰国",
        },
        {
          code: "+255",
          area: "坦桑尼亚",
          key: "+255:坦桑尼亚",
        },
        {
          code: "+1868",
          area: "特立尼达和多巴哥",
          key: "+1868:特立尼达和多巴哥",
        },
        {
          code: "+90",
          area: "土耳其",
          key: "+90:土耳其",
        },
        {
          code: "+993",
          area: "土库曼斯坦",
          key: "+993:土库曼斯坦",
        },
        {
          code: "+216",
          area: "突尼斯",
          key: "+216:突尼斯",
        },
        {
          code: "+502",
          area: "危地马拉",
          key: "+502:危地马拉",
        },
        {
          code: "+58",
          area: "委内瑞拉",
          key: "+58:委内瑞拉",
        },
        {
          code: "+673",
          area: "文莱",
          key: "+673:文莱",
        },
        {
          code: "+256",
          area: "乌干达",
          key: "+256:乌干达",
        },
        {
          code: "+380",
          area: "乌克兰",
          key: "+380:乌克兰",
        },
        {
          code: "+598",
          area: "乌拉圭",
          key: "+598:乌拉圭",
        },
        {
          code: "+998",
          area: "乌兹别克斯坦",
          key: "+998:乌兹别克斯坦",
        },
        {
          code: "+34",
          area: "西班牙",
          key: "+34:西班牙",
        },
        {
          code: "+30",
          area: "希腊",
          key: "+30:希腊",
        },
        {
          code: "+36",
          area: "匈牙利",
          key: "+36:匈牙利",
        },
        {
          code: "+1876",
          area: "牙买加",
          key: "+1876:牙买加",
        },
        {
          code: "+967",
          area: "也门",
          key: "+967:也门",
        },
        {
          code: "+39",
          area: "意大利",
          key: "+39:意大利",
        },
        {
          code: "+972",
          area: "以色列",
          key: "+972:以色列",
        },
        {
          code: "+91",
          area: "印度",
          key: "+91:印度",
        },
        {
          code: "+62",
          area: "印度尼西亚",
          key: "+62:印度尼西亚",
        },
        {
          code: "+44",
          area: "英国",
          key: "+44:英国",
        },
        {
          code: "+1284",
          area: "英属维尔京群岛",
          key: "+1284:英属维尔京群岛",
        },
        {
          code: "+962",
          area: "约旦",
          key: "+962:约旦",
        },
        {
          code: "+84",
          area: "越南",
          key: "+84:越南",
        },
        {
          code: "+260",
          area: "赞比亚",
          key: "+260:赞比亚",
        },
        {
          code: "+235",
          area: "乍得",
          key: "+235:乍得",
        },
        {
          code: "+56",
          area: "智利",
          key: "+56:智利",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.form.country_code = this.form.country_code.split(":")[0];
  },
  methods: {
    changeCode(e) {
      this.form.country_code = e.split(":")[0];
      // return e.split(":")[0];
    },
  },
};
